import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getAdPreviewContainerBaseStyles, } from '../styles';

const ContainerBase = (props) => {
  const {
    titleText,
    isValid,
    onRenderHeader,
    onRenderPlacement,
    onRenderFooter,
    children,
    classes,
    previewContainerClassName,
    containerHeaderClassName,
    containerTitleClassName,
    containerFooterClassName,
    placementContainerClassName,
  } = props;

  return (
    <div className={classnames(classes.adPreviewContainer, !isValid && classes.adPreviewContainerError, previewContainerClassName)}>
      <div className={classnames(classes.adPreviewContainerHeader, containerHeaderClassName, 'ad-preview-title')}>
        {onRenderHeader ? onRenderHeader(props) : (
          titleText && <div className={classnames(classes.adPreviewContainerTitle, containerTitleClassName)}>{titleText}</div>
        )}
      </div>
      <div className={classnames(classes.adPreviewPlacementContainer, placementContainerClassName, 'ad-placement-preview')}>
        {onRenderPlacement ? onRenderPlacement(props) : children}
      </div>
      <div className={classnames(classes.adPreviewContainerFooter, containerFooterClassName)}>
        {onRenderFooter ? onRenderFooter() : null}
      </div>
    </div>
  );
};

ContainerBase.propTypes = {
  titleText: PropTypes.string,
  isValid: PropTypes.bool,
  onRenderHeader: PropTypes.func,
  onRenderFooter: PropTypes.func,
  onRenderPlacement: PropTypes.func,
  classes: PropTypes.shape({
    adPreviewContainer: PropTypes.string,
    adPreviewContainerError: PropTypes.string,
    adPreviewContainerHeader: PropTypes.string,
    adPreviewContainerTitle: PropTypes.string,
    adPreviewPlacementContainer: PropTypes.string,
    adPreviewContainerFooter: PropTypes.string,
  }).isRequired,
  children: PropTypes.node.isRequired,
  previewContainerClassName: PropTypes.string,
  containerHeaderClassName: PropTypes.string,
  containerTitleClassName: PropTypes.string,
  containerFooterClassName: PropTypes.string,
  placementContainerClassName: PropTypes.string,
};

ContainerBase.defaultProps = {
  titleText: undefined,
  onRenderHeader: undefined,
  onRenderFooter: undefined,
  onRenderPlacement: undefined,
  isValid: true,
  previewContainerClassName: undefined,
  containerHeaderClassName: undefined,
  containerTitleClassName: undefined,
  containerFooterClassName: undefined,
  placementContainerClassName: undefined,
};

export const AdPreviewPlacementContainerBase = withUAPLThemedStyles(
  ContainerBase,
  getAdPreviewContainerBaseStyles,
  { componentName: 'AdPreviewPlacementContainerBase' }
);
